module.exports = __webpack_public_path__ + "static/teamsFallback@2x-39610bc44eac8935cd1b2248416f5f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/teamsFallback@2x.jpg
// module id = 2585
// module chunks = 168707334958949